module.exports = __webpack_public_path__ + "img/rem7.536276f4.jpg";